import React, { Component } from 'react';
import { Leaf, Star, Heart, Sparkles, ArrowRight, CheckCircle2, PenTool } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/tf6TyLNmTBPF9G9eK3FM9T/tapa_master_primer_ebook.jpg';
const MOCKUP_IMAGE = 'https://cdn.magicpatterns.com/uploads/sLFEZGJbufNCoyupgJVHMh/mockup_tapa_master2.png';
// Hand-drawn SVG Components
const Underline = () => <svg viewBox="0 0 200 20" className="w-full h-auto text-[#D4735E] opacity-80" preserveAspectRatio="none" data-id="element-2">
    <path d="M5,15 Q50,5 100,12 T195,10" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" data-id="element-3" />
  </svg>;
const Circle = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 100 100" className={`absolute pointer-events-none ${className}`} preserveAspectRatio="none" data-id="element-4">
    <path d="M10,50 Q20,10 50,10 T90,50 T50,90 T10,50" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeDasharray="5,5" data-id="element-5" />
  </svg>;
const ArrowDoodle = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 100 50" className={`absolute pointer-events-none ${className}`} preserveAspectRatio="none" data-id="element-6">
    <path d="M10,40 Q40,10 90,20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-7" />
    <path d="M80,15 L90,20 L85,30" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-8" />
  </svg>;
const BrushStroke = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 300 30" className={`w-full h-auto ${className}`} preserveAspectRatio="none" data-id="element-9">
    <path d="M5,15 Q50,5 150,20 T295,10" fill="none" stroke="currentColor" strokeWidth="15" strokeLinecap="round" opacity="0.2" data-id="element-10" />
  </svg>;
const WaxSeal = () => <div className="relative w-24 h-24 flex items-center justify-center" data-id="element-11">
    <div className="absolute inset-0 bg-[#D4735E] rounded-full opacity-90" style={{
    clipPath: 'polygon(10% 0, 90% 0, 100% 10%, 100% 90%, 90% 100%, 10% 100%, 0 90%, 0 10%)',
    borderRadius: '50%'
  }} data-id="element-12"></div>
    <div className="absolute inset-2 border-2 border-[#FAF6F1] rounded-full opacity-50" data-id="element-13"></div>
    <div className="relative text-[#FAF6F1] text-center transform -rotate-12" data-id="element-14">
      <span className="block text-xs font-bold tracking-widest uppercase" data-id="element-15">
        Garantía
      </span>
      <span className="block text-lg font-handwriting font-bold" data-id="element-16">100%</span>
    </div>
  </div>;
export function LandingPage() {
  return <div className="min-h-screen bg-[#FAF6F1] text-[#2C2C2C] font-serif selection:bg-[#E8967D] selection:text-white overflow-x-hidden" data-id="element-17">
      {/* Texture Overlay */}
      <div className="fixed inset-0 pointer-events-none opacity-40 z-0" style={{
      backgroundImage: 'url("https://www.transparenttextures.com/patterns/cream-paper.png")'
    }} data-id="element-18"></div>

      {/* Navigation / Header */}
      <nav className="sticky top-0 z-50 w-full py-4 px-4 md:px-8 flex justify-center bg-[#FAF6F1]/90 backdrop-blur-sm border-b-2 border-[#D4735E]/20" style={{
      borderBottomStyle: 'dashed'
    }} data-id="element-19">
        <div className="relative" data-id="element-20">
          <span className="relative z-10 text-[#6B7456] font-bold tracking-widest uppercase text-lg md:text-xl lg:text-2xl font-handwriting transform -rotate-1 inline-block" data-id="element-21">
            Belleza Natural en Casa
          </span>
          <div className="absolute -bottom-1 left-0 w-full h-2 bg-[#F4C430]/30 -z-0 transform rotate-1 rounded-full" data-id="element-22"></div>
        </div>
      </nav>

      <main className="relative w-full max-w-6xl mx-auto px-6 md:px-12 py-16 md:py-24 z-10" data-id="element-23">
        {/* Hero Section */}
        <section className="relative mb-32 md:mb-40" data-id="element-24">
          {/* Watercolor Background */}
          <div className="absolute -top-20 -left-20 w-[120%] h-[120%] bg-gradient-to-br from-[#E8967D]/20 via-[#F4C430]/10 to-transparent rounded-full blur-3xl opacity-60 animate-watercolor -z-10" data-id="element-25"></div>

          <div className="max-w-4xl mx-auto text-center relative" data-id="element-26">
            <div className="absolute -top-12 -right-4 md:-right-12 transform rotate-12 animate-bounce duration-[3000ms]" data-id="element-27">
              <span className="font-handwriting text-2xl text-[#D4735E] bg-[#FAF6F1] px-4 py-2 shadow-sm border border-[#D4735E]/30 rounded-tl-xl rounded-br-xl transform rotate-3 inline-block" data-id="element-28">
                ¡Vuelve a lo esencial!
              </span>
              <ArrowDoodle className="w-16 h-16 text-[#6B7456] transform rotate-90 -ml-4 mt-2" data-id="element-29" />
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-medium text-[#6B7456] leading-[1.1] tracking-tight mb-8 drop-shadow-sm" data-id="element-30">
              Hubo un tiempo en el que cuidarse no significaba llenar el baño de{' '}
              <span className="relative inline-block" data-id="element-31">
                frascos caros
                <Underline data-id="element-32" />
              </span>
              .
            </h1>

            <div className="max-w-2xl mx-auto bg-white/60 p-8 rounded-lg backdrop-blur-sm border border-[#D4735E]/20 shadow-lg transform -rotate-1" data-id="element-33">
              <div className="space-y-6 text-xl md:text-2xl leading-relaxed text-[#5A5A5A]" data-id="element-34">
                <p className="font-light italic" data-id="element-35">
                  Un tiempo en el que la belleza se preparaba en casa. En la
                  cocina, con ingredientes que reconocías.
                </p>
                <p className="font-handwriting text-2xl text-[#D4735E] transform rotate-1" data-id="element-36">
                  Sin etiquetas interminables. Sin rutinas de 10 pasos. Sin esa
                  sensación de que "si no compro, no valgo".
                </p>
                <p data-id="element-37">
                  Y aunque hoy te han hecho creer que eso quedó atrás… la verdad
                  es que nunca dejó de funcionar.
                </p>
              </div>
            </div>

            <p className="mt-10 font-bold text-[#D4735E] text-xl md:text-2xl font-handwriting transform rotate-1" data-id="element-38">
              Si estás leyendo esto, probablemente haya algo dentro de ti que ya
              lo sospecha.
            </p>
          </div>
        </section>

        {/* The Mirror Moment - Journal Style */}
        <section className="max-w-3xl mx-auto mb-32 relative" data-id="element-39">
          <div className="absolute -left-12 top-0 text-[#F4C430] transform -rotate-12 opacity-80" data-id="element-40">
            <Sparkles size={64} strokeWidth={1.5} data-id="element-41" />
          </div>

          <div className="bg-white p-8 md:p-12 shadow-xl transform rotate-1 relative paper-shadow" style={{
          borderRadius: '2px'
        }} data-id="element-42">
            {/* Tape Effect */}
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-32 h-8 tape" data-id="element-43"></div>

            <h2 className="text-3xl md:text-4xl text-[#D4735E] font-medium mb-8 font-handwriting" data-id="element-44">
              Tal vez te ha pasado:
            </h2>

            <div className="space-y-6 text-lg md:text-xl leading-relaxed font-serif relative z-10" data-id="element-45">
              <p data-id="element-46">Te miras al espejo y algo no encaja.</p>
              <div className="relative pl-6 border-l-4 border-[#6B7456]/40" data-id="element-47">
                <p data-id="element-48">
                  Miras tu estantería del baño llena de botes y piensas:
                  <span className="block mt-2 font-handwriting text-2xl text-[#6B7456] transform -rotate-1" data-id="element-49">
                    "¿Cómo puede ser que, con todo esto, mi piel siga igual de
                    apagada?"
                  </span>
                </p>
              </div>
              <p data-id="element-50">
                Te prometiste que este último producto sí iba a marcar la
                diferencia… y volvió a ser otra decepción silenciosa.
              </p>
            </div>

            <div className="mt-8 pt-8 border-t-2 border-dashed border-[#D4735E]/30 text-center" data-id="element-51">
              <p className="text-xl md:text-2xl font-medium text-[#2C2C2C] font-handwriting" data-id="element-52">
                Si te reconoces en esto, respira. No estás sola. Y no es culpa
                tuya.
              </p>
            </div>
          </div>
        </section>

        {/* The Problem - Collage Style */}
        <section className="max-w-5xl mx-auto mb-32" data-id="element-53">
          <h2 className="text-4xl md:text-5xl text-[#6B7456] font-medium text-center mb-16 relative inline-block left-1/2 transform -translate-x-1/2" data-id="element-54">
            El baño lleno… y la piel apagada
            <div className="absolute -bottom-2 left-0 w-full h-3 bg-[#E8967D]/30 -z-10 transform -rotate-1 rounded-full" data-id="element-55"></div>
          </h2>

          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-56">
            <div className="bg-[#FAF6F1] p-8 md:p-10 border-2 border-[#2C2C2C] hand-drawn-border transform -rotate-2 relative z-10 bg-white" data-id="element-57">
              <div className="space-y-4 text-lg leading-relaxed" data-id="element-58">
                <p className="font-bold text-[#6B7456] uppercase tracking-wider text-sm" data-id="element-59">
                  Imagina esta escena
                </p>
                <p data-id="element-60">
                  Es tarde. Por fin tienes un momento para ti. Entras al baño,
                  abres el armario y ahí están:
                </p>
                <ul className="list-none space-y-2 font-handwriting text-xl text-[#D4735E]" data-id="element-61">
                  <li data-id="element-62">• Cremas de día y noche</li>
                  <li data-id="element-63">• Sérums y exfoliantes</li>
                  <li data-id="element-64">• Mascarillas y aceites</li>
                  <li data-id="element-65">• Tónicos interminables...</li>
                </ul>
                <p className="italic text-[#5A5A5A] pt-4 border-t border-[#2C2C2C]/10" data-id="element-66">
                  Pero al mirarte al espejo… la realidad es otra.
                </p>
              </div>
            </div>

            <div className="bg-[#E8967D]/10 p-8 md:p-10 transform rotate-2 relative z-0 paper-shadow" data-id="element-67">
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-[#F4C430]/20 rounded-full blur-xl" data-id="element-68"></div>
              <div className="space-y-6 text-lg md:text-xl leading-relaxed" data-id="element-69">
                <p data-id="element-70">
                  La piel se ve cansada. El cabello ha perdido vida. Y tú te
                  sientes un poco estafada.
                </p>
                <p data-id="element-71">
                  No por un producto en concreto, sino por la idea entera de que
                  cuidarte tiene que ser tan complicado, tan caro y tan confuso.
                </p>
                <div className="relative" data-id="element-72">
                  <ArrowDoodle className="w-12 h-12 text-[#6B7456] absolute -left-8 top-0 transform -rotate-45" data-id="element-73" />
                  <p className="font-handwriting text-2xl text-[#D4735E] pl-6" data-id="element-74">
                    "¿De verdad esto es necesario para estar bien con mi piel?"
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Brush Stroke Divider */}
        <div className="flex justify-center my-20 opacity-60 text-[#D4735E]" data-id="element-75">
          <BrushStroke className="w-64" data-id="element-76" />
        </div>

        {/* The Real Problem - Notebook Style */}
        <section className="max-w-4xl mx-auto mb-32 relative" data-id="element-77">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#6B7456] text-[#FAF6F1] px-6 py-2 rounded-sm shadow-md z-20 font-bold tracking-widest uppercase text-sm rotate-1" data-id="element-78">
            La Verdad
          </div>

          <div className="bg-white border border-[#D4735E]/20 p-8 md:p-16 shadow-2xl relative" style={{
          backgroundImage: 'linear-gradient(#E5E5E5 1px, transparent 1px)',
          backgroundSize: '100% 2rem'
        }} data-id="element-79">
            <div className="absolute left-8 top-0 bottom-0 w-px bg-[#D4735E]/30" data-id="element-80"></div>

            <h2 className="text-3xl md:text-4xl text-[#2C2C2C] font-medium mb-8 pl-8 relative z-10" data-id="element-81">
              El problema real no es tu piel
            </h2>

            <div className="space-y-8 text-lg md:text-xl leading-[2rem] pl-8 relative z-10 font-handwriting text-[#5A5A5A]" data-id="element-82">
              <p className="font-serif text-[#2C2C2C]" data-id="element-83">
                Nos han repetido una y otra vez:
              </p>
              <ul className="space-y-2 pl-4 border-l-2 border-[#6B7456]/30 ml-2" data-id="element-84">
                <li data-id="element-85">"Es la edad."</li>
                <li data-id="element-86">"Es tu tipo de piel."</li>
                <li data-id="element-87">"Es que tienes que probar esta nueva rutina."</li>
              </ul>

              <p className="font-bold text-2xl text-[#D4735E] transform -rotate-1 bg-[#FAF6F1]/80 inline-block px-2" data-id="element-88">
                Pero la verdad es otra.
              </p>

              <p className="font-serif text-[#2C2C2C]" data-id="element-89">
                El problema es que, durante años, te enseñaron a cuidarte desde
                la compra, no desde el conocimiento.
              </p>

              <div className="bg-[#FAF6F1] p-6 rounded-lg border-2 border-dashed border-[#6B7456]/30 transform rotate-1 mt-8" data-id="element-90">
                <p className="mb-4 font-bold text-[#6B7456] font-serif" data-id="element-91">
                  Te hicieron creer que:
                </p>
                <ul className="space-y-3 font-serif text-base" data-id="element-92">
                  <li className="flex items-start gap-3" data-id="element-93">
                    <span className="text-[#D4735E] font-bold" data-id="element-94">✕</span>
                    <span data-id="element-95">Lo simple no era suficiente.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-96">
                    <span className="text-[#D4735E] font-bold" data-id="element-97">✕</span>
                    <span data-id="element-98">Lo casero era "poco profesional".</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-99">
                    <span className="text-[#D4735E] font-bold" data-id="element-100">✕</span>
                    <span data-id="element-101">Lo natural funcionaba "hasta cierto punto".</span>
                  </li>
                </ul>
              </div>

              <p className="font-serif text-[#2C2C2C] mt-8" data-id="element-102">
                Te alejaron de lo esencial. Te desconectaron de tu propia
                sabiduría.
              </p>
            </div>
          </div>
        </section>

        {/* Guilt Section */}
        <section className="max-w-3xl mx-auto mb-32 text-center" data-id="element-103">
          <h2 className="text-3xl md:text-4xl text-[#D4735E] font-medium mb-12 font-handwriting transform -rotate-1" data-id="element-104">
            Cuando cuidarte se convierte en una fuente de culpa
          </h2>

          <div className="grid gap-6 text-left" data-id="element-105">
            <div className="bg-white p-6 shadow-md transform rotate-1 border-t-4 border-[#6B7456]" data-id="element-106">
              <p className="text-lg" data-id="element-107">
                Ves rutinas en redes sociales con 8, 10 o 12 pasos y piensas:{' '}
                <span className="font-handwriting text-xl text-[#6B7456]" data-id="element-108">
                  "Yo no tengo tiempo para eso."
                </span>
              </p>
            </div>
            <div className="bg-white p-6 shadow-md transform -rotate-1 border-t-4 border-[#E8967D]" data-id="element-109">
              <p className="text-lg" data-id="element-110">
                Te prometes empezar una rutina perfecta el lunes… y el jueves ya
                estás exhausta.
              </p>
            </div>
            <div className="bg-white p-6 shadow-md transform rotate-1 border-t-4 border-[#F4C430]" data-id="element-111">
              <p className="text-lg" data-id="element-112">
                Y, en el fondo, hay una idea que duele:{' '}
                <span className="font-handwriting text-xl text-[#D4735E]" data-id="element-113">
                  "Si no llego a todo, no me estoy cuidando como debería."
                </span>
              </p>
            </div>
          </div>

          <div className="mt-16 relative inline-block" data-id="element-114">
            <div className="absolute inset-0 bg-[#F4C430]/20 transform rotate-2 rounded-lg -z-10" data-id="element-115"></div>
            <div className="bg-white border-2 border-[#2C2C2C] p-8 hand-drawn-border" data-id="element-116">
              <p className="text-2xl md:text-3xl font-handwriting text-[#6B7456] leading-relaxed" data-id="element-117">
                Pero aquí viene una verdad que nadie te dijo con claridad:
                <br data-id="element-118" />
                <span className="font-bold text-[#D4735E]" data-id="element-119">
                  Cuidarte no debería complicarte la vida. Debería devolvértela.
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* Philosophy Shift - Scrapbook Style */}
        <section className="max-w-5xl mx-auto mb-32" data-id="element-120">
          <div className="relative p-8 md:p-16" data-id="element-121">
            {/* Background Wash */}
            <div className="absolute inset-0 bg-[#FAF6F1] border-2 border-[#6B7456]/20 rounded-3xl transform rotate-1 shadow-xl" data-id="element-122"></div>
            <div className="absolute inset-0 bg-gradient-to-br from-[#E8967D]/10 to-transparent rounded-3xl transform -rotate-1" data-id="element-123"></div>

            <div className="relative z-10" data-id="element-124">
              <h2 className="text-3xl md:text-5xl text-[#6B7456] font-medium mb-16 text-center font-handwriting" data-id="element-125">
                La belleza natural no se crea. Se restaura.
              </h2>

              <div className="grid md:grid-cols-3 gap-8" data-id="element-126">
                <div className="bg-white p-6 rounded-lg shadow-md transform -rotate-2 hover:rotate-0 transition-transform duration-300 border border-[#D4735E]/10" data-id="element-127">
                  <div className="w-12 h-12 bg-[#FAF6F1] rounded-full flex items-center justify-center mb-4 mx-auto border-2 border-[#D4735E] border-dashed" data-id="element-128">
                    <Leaf className="text-[#D4735E]" size={24} data-id="element-129" />
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-[#2C2C2C] text-center font-handwriting" data-id="element-130">
                    Como volver a cocinar en casa
                  </h3>
                  <p className="text-[#5A5A5A] text-sm leading-relaxed text-center" data-id="element-131">
                    Después de años de ultraprocesados. Tu cuerpo recuerda lo
                    natural. Lo reconoce. Responde distinto.
                  </p>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md transform rotate-2 hover:rotate-0 transition-transform duration-300 border border-[#D4735E]/10 mt-8 md:mt-0" data-id="element-132">
                  <div className="w-12 h-12 bg-[#FAF6F1] rounded-full flex items-center justify-center mb-4 mx-auto border-2 border-[#D4735E] border-dashed" data-id="element-133">
                    <Sparkles className="text-[#D4735E]" size={24} data-id="element-134" />
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-[#2C2C2C] text-center font-handwriting" data-id="element-135">
                    Como limpiar una ventana empañada
                  </h3>
                  <p className="text-[#5A5A5A] text-sm leading-relaxed text-center" data-id="element-136">
                    No necesitas añadir más cosas. Solo retiras lo que sobra y,
                    de repente, ves con claridad.
                  </p>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md transform -rotate-1 hover:rotate-0 transition-transform duration-300 border border-[#D4735E]/10" data-id="element-137">
                  <div className="w-12 h-12 bg-[#FAF6F1] rounded-full flex items-center justify-center mb-4 mx-auto border-2 border-[#D4735E] border-dashed" data-id="element-138">
                    <Heart className="text-[#D4735E]" size={24} data-id="element-139" />
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-[#2C2C2C] text-center font-handwriting" data-id="element-140">
                    Como heredar un cuaderno de recetas
                  </h3>
                  <p className="text-[#5A5A5A] text-sm leading-relaxed text-center" data-id="element-141">
                    Nada es estrafalario. Nada es excesivo. Son cosas simples…
                    que siguen funcionando hoy.
                  </p>
                </div>
              </div>

              <div className="mt-16 text-center" data-id="element-142">
                <p className="text-xl md:text-2xl font-medium text-[#6B7456] font-handwriting bg-white/80 inline-block px-6 py-3 rounded-full shadow-sm border border-[#6B7456]/20 transform rotate-1" data-id="element-143">
                  No necesitas más capas. Necesitas menos ruido.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Failed Solutions - Torn Paper List */}
        <section className="max-w-3xl mx-auto mb-32" data-id="element-144">
          <h2 className="text-3xl md:text-4xl text-[#2C2C2C] font-medium mb-12 text-center" data-id="element-145">
            La verdad sobre las soluciones que ya probaste
          </h2>

          <div className="space-y-6" data-id="element-146">
            {[{
            title: 'Cosmética comercial',
            desc: 'Diseñada para que vuelvas a comprar, no para que entiendas tu piel.',
            color: 'border-[#D4735E]'
          }, {
            title: "Productos 'naturales' industrializados",
            desc: 'Etiquetas verdes, pero sigues sin saber qué estás poniendo en tu piel.',
            color: 'border-[#6B7456]'
          }, {
            title: 'Rutinas interminables',
            desc: 'Terminan generando culpa cuando no puedes seguir el ritmo de 10 pasos.',
            color: 'border-[#F4C430]'
          }].map((item, i) => <div key={i} className={`bg-white p-6 border-l-8 ${item.color} shadow-sm transform ${i % 2 === 0 ? 'rotate-1' : '-rotate-1'} hover:rotate-0 transition-transform`} data-id="element-147">
                <h3 className="font-bold text-lg mb-2 font-serif" data-id="element-148">
                  {item.title}
                </h3>
                <p className="text-[#5A5A5A] font-handwriting text-xl" data-id="element-149">
                  {item.desc}
                </p>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-150">
            <p className="text-xl font-medium text-[#D4735E] font-handwriting transform -rotate-1" data-id="element-151">
              No es que tú hayas fallado. El sistema está diseñado así.
            </p>
          </div>
        </section>

        {/* Solution / Product Intro - Golden Hour Feel */}
        <section className="max-w-5xl mx-auto mb-32 relative" data-id="element-152">
          <div className="absolute inset-0 bg-gradient-to-r from-[#F4C430]/10 to-[#E8967D]/10 rounded-3xl blur-3xl -z-10" data-id="element-153"></div>

          <div className="text-center mb-16" data-id="element-154">
            <span className="inline-block px-4 py-1 bg-[#D4735E] text-[#FAF6F1] font-bold text-sm tracking-widest uppercase transform -rotate-2 shadow-md mb-6" data-id="element-155">
              La pieza que faltaba
            </span>
            <h2 className="text-4xl md:text-6xl text-[#6B7456] font-medium font-handwriting mb-6" data-id="element-156">
              Rituales Caseros Conscientes
            </h2>
            <p className="text-xl text-[#5A5A5A] max-w-2xl mx-auto font-serif" data-id="element-157">
              El problema no es que te falte fuerza de voluntad. Es que te
              faltaba un enfoque distinto.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-158">
            <div className="order-2 md:order-1 space-y-8 bg-white/80 p-8 rounded-2xl border border-[#D4735E]/20 shadow-lg backdrop-blur-sm" data-id="element-159">
              <h3 className="text-2xl font-bold text-[#2C2C2C] font-handwriting" data-id="element-160">
                ¿Qué significa esto?
              </h3>
              <ul className="space-y-4" data-id="element-161">
                <li className="flex gap-4 items-start" data-id="element-162">
                  <CheckCircle2 className="text-[#6B7456] shrink-0 mt-1" size={20} data-id="element-163" />
                  <span className="font-handwriting text-xl text-[#5A5A5A]" data-id="element-164">
                    No son recetas sueltas que olvidas al día siguiente.
                  </span>
                </li>
                <li className="flex gap-4 items-start" data-id="element-165">
                  <CheckCircle2 className="text-[#6B7456] shrink-0 mt-1" size={20} data-id="element-166" />
                  <span className="font-handwriting text-xl text-[#5A5A5A]" data-id="element-167">
                    No son truquitos virales vacíos.
                  </span>
                </li>
                <li className="flex gap-4 items-start" data-id="element-168">
                  <CheckCircle2 className="text-[#6B7456] shrink-0 mt-1" size={20} data-id="element-169" />
                  <span className="font-handwriting text-xl text-[#5A5A5A]" data-id="element-170">
                    Son prácticas que conectan cuerpo y hábitos.
                  </span>
                </li>
              </ul>
              <div className="pt-4 border-t border-dashed border-[#D4735E]/30" data-id="element-171">
                <p className="font-bold text-[#D4735E] italic text-lg transform rotate-1" data-id="element-172">
                  "Sé qué hago, por qué lo hago y cómo me hace sentir."
                </p>
              </div>
            </div>

            <div className="order-1 md:order-2 flex justify-center relative" data-id="element-173">
              <div className="relative transform rotate-3 hover:rotate-0 transition-all duration-500" data-id="element-174">
                {/* Photo Frame Effect */}
                <div className="bg-white p-4 pb-12 shadow-2xl border border-gray-200" data-id="element-175">
                  <img src={PRODUCT_IMAGE} alt="Belleza Natural en Casa Ebook Cover" className="w-full max-w-xs" data-id="element-176" />
                  <div className="absolute bottom-4 right-4 font-handwriting text-[#5A5A5A] opacity-60 text-sm" data-id="element-177">
                    Volver a lo natural...
                  </div>
                </div>
                {/* Tape on corners */}
                <div className="absolute -top-3 -left-3 w-20 h-6 tape transform -rotate-45" data-id="element-178"></div>
                <div className="absolute -bottom-3 -right-3 w-20 h-6 tape transform -rotate-45" data-id="element-179"></div>

                {/* Wax Seal Badge */}
                <div className="absolute -top-6 -right-6 transform rotate-12 drop-shadow-lg" data-id="element-180">
                  <WaxSeal data-id="element-181" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Product Reveal - Artisan Card */}
        <section className="max-w-4xl mx-auto mb-32" data-id="element-182">
          <div className="bg-[#FAF6F1] border-2 border-[#2C2C2C] p-8 md:p-12 hand-drawn-border relative bg-white" data-id="element-183">
            <div className="text-center space-y-6" data-id="element-184">
              <h2 className="text-3xl md:text-5xl text-[#2C2C2C] font-medium font-handwriting" data-id="element-185">
                Te presento: Belleza Natural en Casa
              </h2>
              <p className="text-xl text-[#6B7456] font-serif italic" data-id="element-186">
                5 Rituales Caseros que Transforman tu Piel, tu Cabello y tu
                Rutina
              </p>

              <div className="bg-[#F4C430]/10 p-6 rounded-lg transform -rotate-1 my-8 border border-[#F4C430]/30" data-id="element-187">
                <p className="text-lg leading-relaxed font-handwriting text-2xl text-[#5A5A5A]" data-id="element-188">
                  Este ebook nace de ese momento de crisis. En lugar de seguir
                  añadiendo cosas, hizo algo diferente:{' '}
                  <span className="text-[#D4735E] font-bold" data-id="element-189">
                    Recordó las recetas de antes.
                  </span>
                </p>
              </div>

              <button onClick={() => {
              document.getElementById('pricing')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }} className="group relative inline-block cursor-pointer" data-id="element-190">
                <div className="absolute inset-0 bg-[#2C2C2C] rounded-full transform translate-y-1 translate-x-1" data-id="element-191"></div>
                <div className="relative bg-[#D4735E] hover:bg-[#C86850] text-[#FAF6F1] font-bold text-xl px-10 py-4 rounded-full border-2 border-[#2C2C2C] transition-transform transform active:translate-y-1 active:translate-x-1 flex items-center gap-3" data-id="element-192">
                  Accede Ahora al Ebook{' '}
                  <ArrowRight size={24} className="group-hover:translate-x-1 transition-transform" data-id="element-193" />
                </div>
              </button>
            </div>
          </div>
        </section>

        {/* What's Inside - Grid Collage */}
        <section className="max-w-5xl mx-auto mb-32" data-id="element-194">
          <div className="relative" data-id="element-195">
            <div className="absolute inset-0 bg-[#6B7456] transform rotate-1 rounded-3xl shadow-xl -z-10" data-id="element-196"></div>
            <div className="bg-[#FAF6F1] rounded-3xl p-8 md:p-16 border-2 border-[#6B7456]/20 relative overflow-hidden" data-id="element-197">
              {/* Decorative Blobs */}
              <div className="absolute -top-20 -right-20 w-64 h-64 bg-[#E8967D]/20 rounded-full blur-3xl" data-id="element-198"></div>
              <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-[#F4C430]/20 rounded-full blur-3xl" data-id="element-199"></div>

              <h2 className="text-3xl md:text-4xl font-medium mb-12 text-center relative z-10 font-handwriting text-[#6B7456]" data-id="element-200">
                ¿Qué vas a encontrar dentro?
              </h2>

              <div className="grid md:grid-cols-2 gap-12 relative z-10" data-id="element-201">
                <div className="space-y-6" data-id="element-202">
                  <p className="text-lg opacity-90 font-serif" data-id="element-203">
                    No son 100 rituales imposibles. Son 5 rituales claros,
                    replicables y adaptables.
                  </p>
                  <ul className="space-y-4" data-id="element-204">
                    {['Fácil de entender, sin conocimientos previos.', 'Ingredientes simples y cercanos.', 'Encaja en el ritmo real de tu vida.'].map((item, i) => <li key={i} className="flex items-start gap-3 transform hover:translate-x-1 transition-transform" data-id="element-205">
                        <div className="bg-[#D4735E]/20 p-1 rounded-full mt-1" data-id="element-206">
                          <CheckCircle2 size={16} className="text-[#D4735E]" data-id="element-207" />
                        </div>
                        <span className="font-handwriting text-xl text-[#2C2C2C]" data-id="element-208">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>

                <div className="bg-white p-8 rounded-xl shadow-lg transform rotate-2 border border-[#6B7456]/10" data-id="element-209">
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 w-16 h-4 bg-[#D4735E]/30 rounded-full blur-sm" data-id="element-210"></div>
                  <h3 className="text-2xl font-handwriting mb-6 text-[#D4735E] text-center" data-id="element-211">
                    Resultados Reales
                  </h3>
                  <ul className="space-y-4 text-sm md:text-base font-serif" data-id="element-212">
                    <li className="flex gap-3 items-center" data-id="element-213">
                      <Leaf size={16} className="text-[#6B7456]" data-id="element-214" />
                      <span data-id="element-215">Piel más equilibrada y menos reactiva.</span>
                    </li>
                    <li className="flex gap-3 items-center" data-id="element-216">
                      <Leaf size={16} className="text-[#6B7456]" data-id="element-217" />
                      <span data-id="element-218">Cabello más vivo desde la raíz.</span>
                    </li>
                    <li className="flex gap-3 items-center" data-id="element-219">
                      <Leaf size={16} className="text-[#6B7456]" data-id="element-220" />
                      <span data-id="element-221">Rutinas simples y sostenibles.</span>
                    </li>
                    <li className="flex gap-3 items-center" data-id="element-222">
                      <Leaf size={16} className="text-[#6B7456]" data-id="element-223" />
                      <span data-id="element-224">Mayor conexión contigo misma.</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing Section - Ticket Style */}
        <section id="pricing" className="max-w-4xl mx-auto mb-32" data-id="element-225">
          <div className="relative bg-white rounded-lg shadow-2xl overflow-hidden border-2 border-[#D4735E] border-dashed p-2" data-id="element-226">
            <div className="bg-[#FAF6F1] border border-[#D4735E]/20 p-8 md:p-12 rounded-lg relative" data-id="element-227">
              {/* Cutout circles for ticket effect */}
              <div className="absolute top-1/2 -left-4 w-8 h-8 bg-[#FAF6F1] rounded-full border-r-2 border-[#D4735E] border-dashed transform -translate-y-1/2" data-id="element-228"></div>
              <div className="absolute top-1/2 -right-4 w-8 h-8 bg-[#FAF6F1] rounded-full border-l-2 border-[#D4735E] border-dashed transform -translate-y-1/2" data-id="element-229"></div>

              <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-230">
                <div className="relative flex justify-center" data-id="element-231">
                  <div className="absolute inset-0 bg-[#F4C430]/20 rounded-full blur-2xl" data-id="element-232"></div>
                  <img src={MOCKUP_IMAGE} alt="Belleza Natural en Casa - Mockup" className="w-full max-w-xs transform hover:scale-105 transition-transform duration-500 relative z-10 drop-shadow-xl" data-id="element-233" />
                  <div className="absolute -bottom-6 -right-6 z-20 transform rotate-12" data-id="element-234">
                    <div className="w-24 h-24 bg-[#D4735E] rounded-full flex flex-col items-center justify-center text-[#FAF6F1] shadow-lg border-4 border-white border-dashed" data-id="element-235">
                      <span className="text-xs font-bold uppercase" data-id="element-236">Solo</span>
                      <span className="text-2xl font-bold font-handwriting" data-id="element-237">
                        $7.99
                      </span>
                      <span className="text-xs" data-id="element-238">USD</span>
                    </div>
                  </div>
                </div>

                <div className="space-y-6" data-id="element-239">
                  <div data-id="element-240">
                    <h2 className="text-3xl font-medium text-[#2C2C2C] mb-2 font-handwriting" data-id="element-241">
                      Belleza Natural en Casa
                    </h2>
                    <p className="text-sm text-[#5A5A5A] uppercase tracking-wider font-bold text-[#6B7456]" data-id="element-242">
                      Formato Digital • Acceso Inmediato
                    </p>
                  </div>

                  <div className="space-y-3 font-handwriting text-xl text-[#5A5A5A]" data-id="element-243">
                    <div className="flex items-center gap-3" data-id="element-244">
                      <CheckCircle2 size={20} className="text-[#D4735E]" data-id="element-245" />
                      <span data-id="element-246">5 rituales caseros completos</span>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-247">
                      <CheckCircle2 size={20} className="text-[#D4735E]" data-id="element-248" />
                      <span data-id="element-249">Guía práctica paso a paso</span>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-250">
                      <CheckCircle2 size={20} className="text-[#D4735E]" data-id="element-251" />
                      <span data-id="element-252">Ingredientes simples</span>
                    </div>
                  </div>

                  {/* Bonos Section */}
                  <div className="border-t-2 border-dashed border-[#D4735E]/30 pt-6 mt-6" data-id="element-253">
                    <div className="flex items-center gap-2 mb-6" data-id="element-254">
                      <Sparkles size={20} className="text-[#F4C430]" data-id="element-255" />
                      <h3 className="text-2xl font-bold text-[#D4735E] font-handwriting" data-id="element-256">
                        + 2 Bonos Gratis Incluidos
                      </h3>
                      <Sparkles size={20} className="text-[#F4C430]" data-id="element-257" />
                    </div>

                    <div className="space-y-4" data-id="element-258">
                      {/* Bonus 1 */}
                      <div className="bg-gradient-to-br from-[#2C2C2C] to-[#3A3A3A] p-4 rounded-lg border-2 border-[#F4C430]/30 relative overflow-hidden" data-id="element-259">
                        <div className="absolute top-2 right-2 bg-[#F4C430] text-[#2C2C2C] text-xs font-bold px-3 py-1 rounded-full transform rotate-12" data-id="element-260">
                          GRATIS
                        </div>
                        <div className="flex gap-4 items-start" data-id="element-261">
                          <img src="https://cdn.magicpatterns.com/uploads/jyidhr94vjdMp2Mta6AJ9J/mockup_bono_1_tapa.png" alt="Bonus 1 - El Mapa del Baño Despejado" className="w-20 h-20 rounded-lg shadow-md flex-shrink-0" data-id="element-262" />
                          <div className="flex-1" data-id="element-263">
                            <h4 className="text-[#F4C430] font-bold text-sm mb-1" data-id="element-264">
                              BONUS 1 — El Mapa del Baño Despejado™
                            </h4>
                            <p className="text-[#FAF6F1] text-xs leading-relaxed" data-id="element-265">
                              Guía práctica para limpiar tu baño de productos
                              sin culpa, en solo 20 minutos
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Bonus 2 */}
                      <div className="bg-gradient-to-br from-[#F5EFE7] to-[#E8DCC4] p-4 rounded-lg border-2 border-[#6B7456]/30 relative overflow-hidden" data-id="element-266">
                        <div className="absolute top-2 right-2 bg-[#6B7456] text-[#FAF6F1] text-xs font-bold px-3 py-1 rounded-full transform rotate-12" data-id="element-267">
                          GRATIS
                        </div>
                        <div className="flex gap-4 items-start" data-id="element-268">
                          <img src="https://cdn.magicpatterns.com/uploads/hT8E4aj79T9KBiRK4xDnhk/mockup_bono_2_tapa.png" alt="Bonus 2 - Recetario Exprés" className="w-20 h-20 rounded-lg shadow-md flex-shrink-0" data-id="element-269" />
                          <div className="flex-1" data-id="element-270">
                            <h4 className="text-[#6B7456] font-bold text-sm mb-1" data-id="element-271">
                              BONUS 2 — Recetario Exprés de Belleza Casera
                            </h4>
                            <p className="text-[#5A5A5A] text-xs leading-relaxed" data-id="element-272">
                              10 recetas con solo 3 ingredientes para
                              transformar tu piel hoy mismo
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mt-4 text-center" data-id="element-273">
                      <p className="text-sm text-[#D4735E] font-semibold italic" data-id="element-274">
                        Valor total de los bonos: $29.98 • Hoy: GRATIS
                      </p>
                    </div>
                  </div>

                  <button className="w-full bg-[#D4735E] hover:bg-[#C86850] text-[#FAF6F1] font-bold text-lg px-8 py-4 rounded-sm shadow-md transition-all transform hover:-translate-y-1 flex justify-center items-center gap-2 border-2 border-[#2C2C2C] hand-drawn-border" data-id="element-275">
                    Accede Ahora por $7.99 <ArrowRight size={20} data-id="element-276" />
                  </button>

                  <div className="text-center" data-id="element-277">
                    <p className="text-xs text-[#5A5A5A] font-serif italic" data-id="element-278">
                      🔒 Compra 100% segura • Garantía de satisfacción
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Final CTA - Handcrafted */}
        <section className="max-w-4xl mx-auto text-center relative pb-20" data-id="element-279">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-280">
            <WaxSeal data-id="element-281" />
          </div>

          <div className="bg-[#D4735E] text-[#FAF6F1] rounded-t-3xl p-12 md:p-20 shadow-2xl relative overflow-hidden" style={{
          borderRadius: '50% 50% 0 0 / 20% 20% 0 0'
        }} data-id="element-282">
            <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-283"></div>

            <div className="relative z-10 space-y-8 max-w-2xl mx-auto pt-8" data-id="element-284">
              <h2 className="text-4xl md:text-5xl font-medium font-handwriting leading-tight" data-id="element-285">
                Da el primer paso hacia lo natural
              </h2>
              <p className="text-xl opacity-90 font-serif" data-id="element-286">
                Empieza hoy mismo a cuidarte como siempre debió ser:
              </p>
              <p className="text-3xl font-bold font-handwriting text-[#F4C430] transform -rotate-2 inline-block border-b-2 border-[#F4C430] border-dashed pb-1" data-id="element-287">
                Simple. Consciente. Real.
              </p>

              <div className="pt-8" data-id="element-288">
                <button className="bg-[#FAF6F1] text-[#D4735E] hover:bg-white font-bold text-xl px-12 py-5 rounded-full shadow-xl transition-all transform hover:-translate-y-1 inline-flex items-center gap-3 border-4 border-[#D4735E]/30" data-id="element-289">
                  Haz Clic y Vuelve a Casa
                  <ArrowRight size={24} data-id="element-290" />
                </button>
              </div>
            </div>
          </div>
        </section>

        <footer className="bg-[#2C2C2C] text-[#FAF6F1]/60 text-center py-12 text-sm font-serif" data-id="element-291">
          <p data-id="element-292">
            © {new Date().getFullYear()} Belleza Natural en Casa. Hecho con ❤️
            y consciencia.
          </p>
        </footer>
      </main>
    </div>;
}